import { FormattedMessage } from 'dibs-react-intl';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { graphql, useFragment } from 'react-relay';
import { trackFormInteraction } from '../../helpers/checkoutTracking';
import CheckoutSidebarPromotionForm from './CheckoutSidebarPromotionForm';
import { useCheckoutSelector } from '../../reducers/root';
import classnames from 'classnames';
import styles from './styles/CheckoutSidebarPromotionForm.scss';

// components
import { ExpandingArea } from 'dibs-elements/exports/ExpandingArea';

const CheckoutSidebarPromotion = props => {
    const {
        viewer: viewerRef,
        item: itemRef,
        transaction: transactionRef,
        promoCode,
        isComputing,
    } = props;

    const viewer = useFragment(
        graphql`
            fragment CheckoutSidebarPromotion_viewer on Viewer {
                activePromotion(userId: $buyerId, itemId: $itemId) {
                    serviceId
                }
                ...CheckoutSidebarPromotionForm_viewer
            }
        `,
        viewerRef
    );
    const item = useFragment(
        graphql`
            fragment CheckoutSidebarPromotion_item on Item {
                ...CheckoutSidebarPromotionForm_item
            }
        `,
        itemRef
    );
    const transaction = useFragment(
        graphql`
            fragment CheckoutSidebarPromotion_transaction on Transaction {
                ...CheckoutSidebarPromotionForm_transaction
                mostRecentOffer {
                    quantity
                }
                promotions {
                    code
                    isInvalid
                }
            }
        `,
        transactionRef
    );

    const [isOpen, setIsOpen] = useState(!!viewer?.activePromotion?.serviceId);

    useEffect(() => {
        if (isOpen) {
            trackFormInteraction('promo code section expanded');
        }
    }, [isOpen]);

    const isProcessing = useCheckoutSelector(state => state.ui.isProcessing) || false;

    const { code, isInvalid } = transaction?.promotions[0] || {};
    const quantity = transaction?.mostRecentOffer?.quantity;
    const hasError = !quantity || !!(code && isInvalid && promoCode);
    const hasPromo = !!code && !hasError;

    return (
        <ExpandingArea
            showOverflow
            label={
                (!hasPromo && !isOpen) || !isOpen ? (
                    <FormattedMessage
                        id="checkout.CheckoutSidebarPromotion.add"
                        defaultMessage="Add Promotional Code"
                    />
                ) : null
            }
            expanded={isOpen}
            hideCollapsedContent
            wrapperClass={classnames(styles.wrapper, {
                [styles.disabled]: isProcessing,
            })}
            labelClass={styles.promotionLink}
            dataTn="add-promo-code-link"
            onClick={!isComputing ? () => setIsOpen(!isOpen) : () => {}}
        >
            <CheckoutSidebarPromotionForm
                viewer={viewer}
                item={item}
                transaction={transaction}
                isComputing={isComputing}
                onPromoCodeRemove={() => setIsOpen(false)}
            />
        </ExpandingArea>
    );
};

CheckoutSidebarPromotion.propTypes = {
    viewer: PropTypes.object.isRequired,
    item: PropTypes.object.isRequired,
    transaction: PropTypes.object.isRequired,
    promoCode: PropTypes.string.isRequired,
    isComputing: PropTypes.bool.isRequired,
};

export default connect(({ transaction }) => ({
    promoCode: transaction.promoCode || '',
}))(CheckoutSidebarPromotion);
